import globalConfig from '@utiles/globalConfig';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';

/** 预览模式、登录失败 cookie 等场景允许未登录访问 */
export function canAccessOfficialSupportWithoutLogin() {
  return (
    globalConfig.getHrefParam('isReview') == 1 ||
    !!globalConfig.getCookie('login_failed')
  );
}

export function safeGotoLink(link) {
  try {
    return getGlobalGetGotoLink({ link });
  } catch (e) {
    return link;
  }
}

export function getOfficialSupportGameId(store) {
  const urlParams = store?.state?.urlParams || {};
  return (
    urlParams.gameId ||
    globalConfig.getHrefParam('gameId') ||
    globalConfig.getHrefParam('gameID') ||
    globalConfig.getHrefParam('game_id') ||
    ''
  );
}

export function redirectToOfficialSupportLogin(gameId) {
  const gid =
    gameId !== undefined && gameId !== null
      ? gameId
      : getOfficialSupportGameId();
  const forward = encodeURIComponent(safeGotoLink(window.location.href));
  const realHref = `https://gabres.${globalConfig.getMainHost()}/platform/login.html?gameId=${gid}&forward=${forward}`;
  window.location.href = safeGotoLink(realHref);
}

/** 进入前需登录校验的路由（首页、工单列表等入口页） */
export const OFFICIAL_SUPPORT_LOGIN_GUARD_ROUTES = ['workhome', 'mylist'];

export function isOfficialSupportLoginGuardRoute(routeName) {
  return OFFICIAL_SUPPORT_LOGIN_GUARD_ROUTES.includes(routeName);
}

/**
 * 客服入口登录校验，与 WorkTemp 一致走 gabres 登录页
 * @returns {Promise<boolean>} true 可继续导航，false 已跳转登录
 */
export async function guardOfficialSupportLogin(store) {
  if (canAccessOfficialSupportWithoutLogin()) {
    return true;
  }
  try {
    await store.dispatch('checkLogin');
  } catch (e) {
    // checkLogin 失败时仍按未登录处理
  }
  if (store.state.isLogin) {
    return true;
  }
  redirectToOfficialSupportLogin(getOfficialSupportGameId(store));
  return false;
}

/** @deprecated 使用 guardOfficialSupportLogin */
export const guardWorkHomeLogin = guardOfficialSupportLogin;
